function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { ListingType, ListingTypeName } from '@domain-group/fe-allhomes-library';
import { Section, PageType } from '@domain-group/fe-co-allhomes-ads';
var flatten = adKeyValue => Array.isArray(adKeyValue) ? adKeyValue.join(', ') : adKeyValue;
var getAdTargeting = listing => {
  var _category$subCategory, _category$primaryCate;
  if (typeof window === 'undefined') {
    return null;
  }
  var digitalData = window.digitalData || {};
  var _digitalData$page = digitalData.page,
    page = _digitalData$page === void 0 ? {} : _digitalData$page,
    _digitalData$titan = digitalData.titan,
    titan = _digitalData$titan === void 0 ? {} : _digitalData$titan;
  var _page$category = page.category,
    category = _page$category === void 0 ? {} : _page$category;
  var _ref = titan.adKeyValues || {},
    locstate = _ref.locstate,
    locregion = _ref.locregion,
    locarea = _ref.locarea,
    locsuburb = _ref.locsuburb,
    locpostcode = _ref.locpostcode,
    bedexact = _ref.bedexact,
    carexact = _ref.carexact,
    proptypes = _ref.proptypes,
    propertyStatus = _ref.propertyStatus,
    pricerange = _ref.pricerange,
    pricemin = _ref.pricemin,
    pricemax = _ref.pricemax;
  var adKeyValues = Object.fromEntries(Object.entries({
    locstate,
    locregion,
    locarea,
    locsuburb,
    locpostcode,
    bedexact,
    carexact,
    propertyStatus,
    pricerange,
    pricemin,
    pricemax
  }).map(_ref2 => {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return [key, flatten(value)];
  }).filter(_ref4 => {
    var _ref5 = _slicedToArray(_ref4, 2),
      _ = _ref5[0],
      value = _ref5[1];
    return value != null;
  }));
  var getSection = () => {
    if (listing.status === 'SOLD') {
      return Section.Sold;
    }
    var listingType = ListingType[listing.type];
    if (listingType !== null && listingType !== void 0 && listingType.isCommercial) {
      return Section.Commercial;
    }
    switch (listingType.name) {
      case ListingTypeName.DEVELOPMENTS_RESIDENTIAL:
        return Section.NewHomes;
      case ListingTypeName.SHARE_RESIDENTIAL:
      case ListingTypeName.RENTAL_RESIDENTIAL:
        return Section.Rent;
      default:
        return Section.Buy;
    }
  };
  var config = {
    pageType: PageType.Details,
    section: getSection()
  };
  var data = _objectSpread(_objectSpread({
    cat: (_category$subCategory = category.subCategory2) === null || _category$subCategory === void 0 ? void 0 : _category$subCategory.toLowerCase(),
    cat1: (_category$primaryCate = category.primaryCategory) === null || _category$primaryCate === void 0 ? void 0 : _category$primaryCate.toLowerCase(),
    cat2: 'details',
    ctype: 'listing'
  }, adKeyValues), {}, {
    proptype: flatten(proptypes)
  });
  return {
    config,
    data
  };
};
export default getAdTargeting;